var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#b7d2dc",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6651 3178)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(6651 -3178)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6653 -3176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.334,543.06a10.144,10.144,0,0,1-9.814-12.673l10.74,3.89V522.834a10.04,10.04,0,0,1,2.174.444,10.135,10.135,0,0,1-3.1,19.782Z",
    transform: "translate(-249.197 -522.834)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.339,528.215A9.017,9.017,0,0,1,258,522.882v8.106Z",
    transform: "translate(-249.197 -522.834)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.339,528.215A9.017,9.017,0,0,1,258,522.882v8.106Z",
    transform: "translate(-249.197 -522.834)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/stats-icon.156c9d8c.svg";
export { ForwardRef as ReactComponent };